import { render, staticRenderFns } from "./differentDialog.vue?vue&type=template&id=5d26b1da&scoped=true&"
import script from "./differentDialog.vue?vue&type=script&lang=js&"
export * from "./differentDialog.vue?vue&type=script&lang=js&"
import style0 from "./differentDialog.vue?vue&type=style&index=0&id=5d26b1da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d26b1da",
  null
  
)

export default component.exports